var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mb-2" }, [
    _c(
      "div",
      { staticClass: "flex justify-between" },
      [
        _vm.labelShown
          ? _c(
              "label",
              { staticClass: "text-md" },
              [
                _vm._t("title", function () {
                  return [
                    _c("p", { staticClass: "font-bold text-md" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._t("labelAside"),
      ],
      2
    ),
    _c("div", { class: _vm.formInputClass }, [
      _c("div", { staticClass: "mb-1" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }